var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedAdressLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.125 20.5a6.755 6.755 0 00-6.75-6.75 6.755 6.755 0 00-6.75 6.75c0 5.063 6.75 12.375 6.75 12.375s6.75-7.313 6.75-12.375zm-9 0a2.257 2.257 0 012.25-2.25 2.25 2.25 0 11-2.25 2.25zM17.5 34v2.25h15.75V34H17.5z",
    fill: "#FFA700"
  })));
}
export default SvgLedAdressLogo;